export default __webpack_public_path__ + "static/media/outreach.4454efa9.svg";